import { useTracking } from '@vp/react-tracking';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Box, Button, Card, FlexBox, Icon, Typography, tokensRaw } from '@vp/swan';
import { LayeredAvatars } from '@99designs/design-services-common';
import { __, __vistaRoute } from '@99designs/i18n';
import { NEW_PROJECT_ROUTE } from '../utils/constants';

interface PreferredDesignerCTAProps {
    avatarUrls?: ReadonlyArray<string | null | undefined>;
    designerCount: number;
}

export const PreferredDesignerCTA: React.FC<PreferredDesignerCTAProps> = ({
    avatarUrls = [],
    designerCount,
}) => {
    const href = `${__vistaRoute(NEW_PROJECT_ROUTE)}?preferredDesigner=true`;
    const { ref, inView } = useInView({ triggerOnce: true });
    const { tracking } = useTracking();

    const trackingPayload = {
        designerCount,
        pageName: 'Design Services:Dashboard',
        pageSection: 'Design Services',
        pageStage: 'My Account',
    };

    useEffect(() => {
        if (inView) {
            tracking.track('Preferred Designer Cta Viewed', trackingPayload);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView]);

    return (
        <div ref={ref}>
            <Card
                bordered
                style={{
                    backgroundColor: tokensRaw.SwanSemColorBgStrong,
                }}
            >
                <FlexBox flexDirection="column" gap="between-actions">
                    <FlexBox alignItems="center" gap="between-actions" mb={2}>
                        <LayeredAvatars avatarUrls={avatarUrls} size={32} max={3} />
                        <Typography fontSkin="body-standard-bold">
                            {__('Work with your designers again')}
                        </Typography>
                    </FlexBox>
                    <Typography fontSkin="body-standard" mb={2}>
                        {__(
                            "We'll do our best to match your project with your preferred designer. Otherwise, we'll pair you with another expert who'll fit your creative needs."
                        )}
                    </Typography>
                    <Box>
                        <Button
                            skin="primary"
                            iconPosition="right"
                            render={({ children, ...props }) => (
                                <a
                                    {...props}
                                    href={href}
                                    onClick={() => {
                                        tracking.track(
                                            'Preferred Designer Cta Clicked',
                                            trackingPayload
                                        );
                                    }}
                                >
                                    {children}
                                    <Icon iconType="arrowRight" />
                                </a>
                            )}
                        >
                            {__('Start a project with a preferred designer')}
                        </Button>
                    </Box>
                </FlexBox>
            </Card>
        </div>
    );
};
